module.exports = __webpack_public_path__ + "img/solution-3.786e8caa.jpg";